import type { MongoAbility } from '@casl/ability';
import type { EAbilitySubjects } from '@client/hooks/useAbilities';
import type { ESchedulerPrefix, IScheduler } from '@common/types';
import type { DrawerProps, FormInstance } from 'antd';

export const CNsTags = 'tags';

export interface IFieldData {
  name: string[];
  value?: any;
  touched?: boolean;
  validating?: boolean;
  errors?: string[];
}

export type THandleSchedulerForm = {
  disabled: boolean;
  entity: IScheduler | null;
  formRef: FormInstance<IScheduler>;
  handlers: {
    onSave: () => void;
    setLoading: (loading: boolean) => void;
    setOpenDrawer: (open: boolean) => void;
    setConfigDrawer: (configDrawer: DrawerProps) => void;
    setOnRefreshDrawer: (onRefreshDrawer: () => void) => void;
  };
  options: {
    title?: string;
    loading: boolean;
    schedulerType: ESchedulerPrefix;
    isEdit?: boolean;
    isDirty?: boolean;
    ableFor: {
      ability: MongoAbility;
      subject: string | keyof typeof EAbilitySubjects;
    };
    prefix?: string[];
    readOnlyFields?: string[];
  };
};
